"use client"

import { useTranslations } from "next-intl"
import type { ReactNode } from "react"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "~/components/legacy/common/accordion"
import { H2, H6 } from "~/components/legacy/common/heading"

const groups = [
  {
    key: "how_it_works",
    questions: ["what_checks", "crawler_list", "storage"],
  },
  {
    key: "basics",
    questions: ["robots_txt", "google_extended", "waf"],
  },
  {
    key: "scope_legal",
    questions: ["legal", "allowed_use", "can_scrape"],
  },
] as const

const richTags = {
  b: (chunks: ReactNode) => <strong className="text-foreground">{chunks}</strong>,
  code: (chunks: ReactNode) => (
    <code className="rounded bg-muted px-1 py-0.5 font-mono text-xs">{chunks}</code>
  ),
}

export function CheckerFaq() {
  const t = useTranslations("pages.ai_crawler_checker.faq")

  return (
    <div className="flex flex-col gap-8 border-t pt-10">
      <div className="flex max-w-2xl flex-col gap-3">
        <p className="font-mono text-xs font-semibold uppercase tracking-widest text-primary">
          {t("eyebrow")}
        </p>
        <H2 as="h2">{t("title")}</H2>
      </div>

      {groups.map(group => (
        <section key={group.key} className="flex flex-col gap-3">
          <H6 as="h3">{t(`groups.${group.key}.title`)}</H6>
          <Accordion type="single" collapsible className="flex flex-col gap-3">
            {group.questions.map(question => (
              <AccordionItem key={question} value={`${group.key}-${question}`}>
                <AccordionTrigger>
                  {t(`groups.${group.key}.items.${question}.question`)}
                </AccordionTrigger>
                <AccordionContent className="leading-relaxed text-muted-foreground">
                  {t.rich(`groups.${group.key}.items.${question}.answer`, richTags)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>
      ))}
    </div>
  )
}
